import { Component, DestroyRef, effect, inject, input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AbstractControl, FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { SidepanelService } from '@shared/components/sidepanel/sidepanel.service';
import { ToastrSuccessComponent } from '@shared/components/toastr/toastr-success.component';
import { LabelRequiredDirective } from '@shared/directives/label-required.directive';
import { HlmFieldImports } from '@spartan-ng/helm/field';
import { HlmInputImports } from '@spartan-ng/helm/input';
import { toast } from 'ngx-sonner';
import { v7 as uuidv7 } from 'uuid';

import { ParcoursStore } from '../../../référentiel-métier-parcours/store/parcours.store';
import { Parcours } from '../../../référentiel-métier-parcours/models/parcours.model';
import { FormControlNames } from '../../../référentiel-métier-parcours/models/form-control-names.model';
import { Cartographie } from '../../../cartographie/models/cartographie.model';

@Component({
  selector: 'app-referentiel-form',
  imports: [HlmFieldImports, ReactiveFormsModule, LabelRequiredDirective, HlmInputImports],
  templateUrl: './référentiel-form.component.html',
})
export class ParcoursFormComponent implements OnInit {
  readonly #store = inject(ParcoursStore);
  readonly #sidepanelService = inject(SidepanelService);
  readonly #destroyRef = inject(DestroyRef);
  readonly #fb = inject(FormBuilder);

  readonly parcours = input.required<Parcours>();
  readonly cartographie = input.required<Cartographie>();

  form = this.#fb.group({
    [FormControlNames.NOM]: [null, [Validators.required]],
  });

  constructor() {
    effect(() => {
      this.nom.setValue(this.parcours().nom);
      this.#store.select({ id: this.parcours().id });
    });
  }

  ngOnInit(): void {
    this.#sidepanelService.submit.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe(() => this.onSubmit());
  }

  onSubmit() {
    const toastrId = uuidv7();

    if (this.form.invalid) return;

    const nom = this.nom.value;

    this.#store.modifier({
      nom,
      next: () => {
        toast.custom(ToastrSuccessComponent, {
          componentProps: {
            message: `Modification du parcours ${nom} réussie`,
            id: toastrId,
          },
          id: toastrId,
        });
        this.#sidepanelService.close();
        this.#store.chargerParCartographie(this.cartographie().id);
      },
    });
  }

  get nom() {
    return this.form.get(FormControlNames.NOM) as AbstractControl;
  }
}
